import React from 'react';
import { FlexRow } from 'ui-components/components/flex';
import { MDash } from 'ui-components/components/mdash/mdash';

export const EmptyLocation = () => (
  <FlexRow>
    <MDash />
  </FlexRow>
);
